let items = document.querySelectorAll(".mega-menu");
let header = document.querySelector("header");
let currentItemIndex;

items.forEach((item, itemIndex) => {
  const content = item.querySelector(".mega-menu__content");

  item.addEventListener("mouseover", () => {
    if (
      (currentItemIndex === 0 && currentItemIndex !== itemIndex) ||
      (currentItemIndex && currentItemIndex !== itemIndex)
    ) {
      items[currentItemIndex].removeAttribute("open");
    }

    currentItemIndex = itemIndex;
    item.setAttribute("open", true);
  });

  item.addEventListener("mouseleave", (event) => {
    let close = true;

    const closeTimeout = setTimeout(() => {
      if (close) item.removeAttribute("open");
    }, 200);

    content.addEventListener("mouseover", () => {
      close = false;
    });

    item.addEventListener("mouseover", () => {
      clearTimeout(closeTimeout);
    });
  });

  content.addEventListener("mouseleave", () => {
    item.removeAttribute("open");
  });

  item.addEventListener("click",() => {
    let id = item.id
    if( id == 'Details-HeaderMenu-1' ) window.location = '/collections/mattresses'
    else if( id == 'Details-HeaderMenu-2' ) window.location = '/collections/adjustable-beds'
    else if( id == 'Details-HeaderMenu-3' ) window.location = '/collections/bedding'
    else if( id == 'Details-HeaderMenu-4' ) window.location = '/collections/massage-chairs'
  });
});